/**
 * Blog JS
 */

// CSS
import '../scss/blog.scss';

$('html').on('click', event => {
  $('.nav-subnav-toggle').removeClass('is-active');
  $('.nav-subnav-menu').removeClass('is-visible');
});

$('.nav-subnav').on('click', '.nav-subnav-menu-toggle', event => {
  event.preventDefault();
  event.stopPropagation();
  $(event.currentTarget).toggleClass('is-active');
  $('.nav-subnav-menu').toggleClass('is-visible');
});

$('.nav-subnav').on('click', '.nav-subnav-search-toggle', event => {
  event.preventDefault();
  event.stopPropagation();
  $(event.currentTarget).toggleClass('is-active');
  $('.nav-subnav-search').toggleClass('is-visible');

  if ($('.nav-subnav-search').hasClass('is-visible')) {
    setTimeout(() => {
      $('.nav-subnav-search .form-control').focus();
    }, 300);
  }
});



// WEBPACK FOOTER //
// ./assets/js/blog.js